import React, { useEffect, useState } from "react";
import { navigate } from "raviger";
import Carousel from "react-bootstrap/Carousel";
import logo from './../../../assets/img/logo.png';
import EZYCOMP from "./../../../assets/img/EZYCOMP.jpg";
import Aim from "./../../../assets/img/our-aim.jpg";
import OurPromise from "./../../../assets/img/our-promise.jpg";
import Products from "./../../../assets/img/our-product.jpg";
import Performer from "./../../../assets/img/performer.jpg";
import Checker from "./../../../assets/img/checker.jpg";
import Contact from "./../../../assets/img/Contact.jpg";
import { preventDefault } from "../../../utils/common";
import { toast } from 'react-toastify';
import "./Authenticate.css";
import ForgotPasswordModal from "./ForgotPasswordModal";
import FormRenderer, { ComponentMapper, FormTemplate } from "../../common/FormRenderer";
import PageLoader from "../../shared/PageLoader";
import { LOGIN_FIELDS } from "./Authenticate.constants";
import VerifyOTP from "./VerifyOTP";
import PostLoginOTP from "./PostLoginOTP";
import { clearUserSession, getAuthToken, parseToken, setUserSession, useGenerateOTP, useUserLogin } from "../../../backend/auth";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import { getBasePath } from "../../../App";
import { AxiosError } from "axios";
import { useRecaptcha } from "../../../utils/useRecaptcha";

function Login() {
    const [token] = useState(getAuthToken());
    const [forgotPassword, setForgotPassword] = useState(false);
    const [loginWithOtp, setLoginWithOtp] = useState(false);
    const [verifyOTP, setVerifyOTP] = useState(false);
    const [showPostLoginOTP, setShowPostLoginOTP] = useState(false);
    const [currentUsername, setCurrentUsername] = useState('');
    const [currentEmail, setCurrentEmail] = useState('');
    const [schema, setSchema] = useState<any>({ fields: [LOGIN_FIELDS.USERNAME, LOGIN_FIELDS.PASSWORD] });
    const [form, setForm] = useState<any>({});
    const [payload, setPayload] = useState<any>({});
    const { userLogin, isLoading: logging } = useUserLogin((response: any) => {
        if(response instanceof AxiosError) {
            const { data } = (response || {}).response || {};
            let error = (data || {}).error || (data || {}).message || ERROR_MESSAGES.ERROR;
            if((data || {}).attempts_left > 0) {
                error += `. You have ${data.attempts_left} attempt/s left before your account gets locked.`;
            }
            toast.error(error);
            return;
        } else {
            const { status, token, message, email } = (response || {}).data || {};
            if (status === "EMAIL_OTP_REQUIRED") {
                toast.info(message || "OTP has been sent to your registered email");
                setCurrentEmail(email); // Store the actual email entered by user
                // currentEmail is already set from the login form (actual email entered by user)
                setShowPostLoginOTP(true);
            } else if (token) {
                loginCallback({ token });
            } else {
                toast.error(message || ERROR_MESSAGES.ERROR);
            }
        }
    }, errorCallback);
    const { generateOTP, isLoading: generatingOTP } = useGenerateOTP(({ result, message }: any) => {
        if (result === API_RESULT.SUCCESS) {
            setPayload({ ...payload, token: message });
            setVerifyOTP(true);
        } else {
            toast.error(message || ERROR_MESSAGES.ERROR);
        }
    }, errorCallback);
    const { executeRecaptcha } = useRecaptcha();

    function errorCallback(response: any) {
        if(response instanceof AxiosError) {
            const { data } = (response || {}).response || {};
            let error = (data || {}).error || (data || {}).message || ERROR_MESSAGES.ERROR;
            if((data || {}).attempts_left > 0) {
                error += `. You have ${data.attempts_left} attempt/s left before your account gets locked.`;
            }
            toast.error(error);
            return;
        } else {
            toast.error(ERROR_MESSAGES.DEFAULT);
        }
    }

    async function login({ username, password }: any) {
        setCurrentUsername(username);
        
        try {
            const recaptchaToken = await executeRecaptcha('login');
            if (!recaptchaToken) {
                toast.error('reCAPTCHA verification failed. Please try again.');
                return;
            }
            
            userLogin({ username, password, recaptchaToken });
        } catch (error) {
            console.error('reCAPTCHA error:', error);
            toast.error('reCAPTCHA verification failed. Please try again.');
        }
    }

    function loginCallback({ token }: any) {
        setUserSession(token);

        // Check if there's a redirect URL stored
        const redirectUrl = localStorage.getItem('redirectAfterLogin');
        if (redirectUrl) {
            localStorage.removeItem('redirectAfterLogin');
            navigate(redirectUrl);
        } else {
            navigate('/');
        }

        window.location.reload();
    }

    function getOtp({ username }: any) {
        if (form.valid) {
            setPayload({ username });
            generateOTP({ username });
        }
    }

    function showForgotPwd(event: any) {
        preventDefault(event);
        setForgotPassword(true);
    }

    function toggleLoginWithOtp(event: any) {
        preventDefault(event);
        setLoginWithOtp(!loginWithOtp);
        setVerifyOTP(false);
    }

    function handlePostLoginOTPSuccess(token: string) {
        loginCallback({ token });
    }

    function handlePostLoginOTPCancel() {
        setShowPostLoginOTP(false);
        setCurrentUsername('');
        setCurrentEmail('');
    }

    useEffect(() => {
        if (typeof loginWithOtp !== undefined) {
            setSchema(null);
            const fields = [];
            fields.push({ ...LOGIN_FIELDS.USERNAME });
            if (!loginWithOtp) {
                fields.push({
                    ...LOGIN_FIELDS.PASSWORD,
                    description: (
                        <a href="/" onClick={showForgotPwd} className="text-black-600">
                            <small>Forgot Password</small>
                        </a>
                    ),
                })
            }
            setSchema({ fields });
        }
    }, [loginWithOtp]);

    useEffect(() => {
        if (token) {
            clearUserSession();
        }
    }, [token]);

    return (
        <>
            {
                showPostLoginOTP && (
                    <PostLoginOTP 
                        onSuccess={handlePostLoginOTPSuccess}
                        onCancel={handlePostLoginOTPCancel}
                        username={currentUsername}
                        email={currentEmail}
                    />
                )
            }
            {
                !verifyOTP && !showPostLoginOTP &&
                <div className="row m-0 overflow-hidden">
                    <div className="col-md-8 p-0 bannerSlider">
                        <Carousel>
                            <Carousel.Item>
                                <img className="d-block" src={EZYCOMP} alt="First slide" />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="d-block" src={Aim} alt="Second slide" />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="d-block" src={OurPromise} alt="Third slide" />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="d-block" src={Products} alt="Third slide" />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="d-block" src={Performer} alt="Third slide" />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="d-block" src={Checker} alt="Third slide" />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="d-block" src={Contact} alt="Third slide" />
                            </Carousel.Item>
                        </Carousel>
                    </div>

                    <div className="col-md-4 loginSection px-5 py-3">
                        <div className="d-flex flex-column h-100 justify-content-between align-items-center mt-5">
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="navbar-brand p-0 text-center mb-4"><img src={logo} alt="Logo" width="344" /></div>
                                <div className="col-9" style={{ minHeight: loginWithOtp ? '150px' : '250px' }}>
                                    {
                                        schema &&
                                        <>
                                            {
                                                loginWithOtp ? <FormRenderer FormTemplate={FormTemplate}
                                                    initialValues={{ submitBtnText: 'Get OTP', fullWidth: false }}
                                                    componentMapper={ComponentMapper}
                                                    schema={schema}
                                                    debug={setForm}
                                                    onSubmit={getOtp}
                                                    clearOnUnmount={true}
                                                /> :
                                                    <FormRenderer FormTemplate={FormTemplate}
                                                        initialValues={{ submitBtnText: 'Login', fullWidth: false }}
                                                        componentMapper={ComponentMapper}
                                                        debug={setForm}
                                                        schema={schema}
                                                        onSubmit={login}
                                                        clearOnUnmount={true}
                                                    />
                                            }
                                        </>
                                    }
                                </div>
                                {/* SSO Login Option */}
                                <div className="text-center mt-3">
                                    <div className="text-black-600 mb-2"><small>-or-</small></div>
                                    <a
                                        href="/sso-login"
                                        className="text-primary text-decoration-none"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/sso-login');
                                        }}
                                    >
                                        Login with SSO
                                    </a>
                                </div>
                                {/* hiding login with otp ticket ref - 62 */}
                                {false && <>
                                    <div className="text-black-600 mt-3"><small>-or-</small></div>
                                    <a href="/" onClick={toggleLoginWithOtp} className="text-appprimary">{loginWithOtp ? 'Login with Password' : 'Login with OTP'}</a>
                                </>}
                            </div>
                            <div className="">
                                <div className="card"></div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                verifyOTP && <VerifyOTP editUser={() => setVerifyOTP(false)} onCancel={toggleLoginWithOtp}
                    request={payload} onSubmit={loginCallback} />
            }
            {
                forgotPassword && <ForgotPasswordModal onClose={() => setForgotPassword(false)} />
            }
            {
                (logging || generatingOTP) && <PageLoader>
                    {
                        logging && <p>Logging...</p>
                    }
                    {
                        generatingOTP && <p>Generating OTP...</p>
                    }
                </PageLoader>
            }
        </>
    );
}

export default Login;
